import ResizableScene from "../core/ResizableScene";

type Cloud = {
	image: Phaser.GameObjects.Image;
	speed: number;
};

type MinMax = {
	min: number;
	max: number;
};

export type CloudConfig = {
	images: string[];
	spawnTime: MinMax | number;
	speed: MinMax | number;
	maxClouds?: number;
	scale?: MinMax | number;
	minY?: number;
	maxY: number;
};

export default class CloudSpawner extends Phaser.GameObjects.Container {
	scene: ResizableScene;

	config: CloudConfig;

	clouds: Cloud[];

	spawnTimer: number;

	constructor(scene: ResizableScene, config: CloudConfig) {
		super(scene, 0, 0);
		this.clouds = [];

		this.config = config;
		if (!config.maxClouds) config.maxClouds = 0;
		if (!config.minY) config.minY = 0;
		this.setSpawnTimer();
	}

	update(delta: number): void {
		const remove: Phaser.GameObjects.Image[] = [];
		this.clouds.forEach((c) => {
			const cloud = c.image;
			cloud.x += c.speed * delta;
			if (c.speed > 0 && cloud.x > this.scene.viewport.width + cloud.width / 2) remove.push(cloud);
			else if (c.speed < 0 && cloud.x < -cloud.width / 2) remove.push(cloud);
		});
		remove.forEach((cloud) => this.removeCloud(cloud));

		this.spawnTimer -= delta;
		if (this.config.maxClouds > 0 && this.clouds.length >= this.config.maxClouds) return;
		if (this.spawnTimer <= 0) this.spwanCloud();
	}

	spwanCloud(xOffset = 0): void {
		if (this.config.images.length <= 0) return;

		const random = Math.floor(Math.random() * this.config.images.length);
		const image = this.scene.add.image(0, 0, this.config.images[random]);

		const speed = this.getSpeed();
		image.x = speed < 0 ? this.scene.viewport.width + image.width / 2 : -this.width;
		image.x += xOffset;
		image.y = this.getRandomY();
		image.setScale(this.getScale());
		this.add(image);

		this.clouds.push({ image: image, speed: speed });
		this.setSpawnTimer();
	}

	getScale(): number {
		if (this.config.scale) {
			if (typeof this.config.scale == "number") return this.config.scale;
			else {
				const minMax = this.config.scale as MinMax;
				return Phaser.Math.RND.realInRange(minMax.min, minMax.max);
			}
		}
		return 1;
	}

	getSpeed(): number {
		if (typeof this.config.speed == "number") return this.config.speed;
		else {
			const minMax = this.config.speed as MinMax;
			return Phaser.Math.RND.realInRange(minMax.min, minMax.max);
		}
	}

	getRandomY(): number {
		return Phaser.Math.RND.realInRange(this.config.minY, this.config.maxY);
	}

	setSpawnTimer(): void {
		if (typeof this.config.spawnTime == "number") this.spawnTimer = this.config.spawnTime;
		else {
			const minMax = this.config.spawnTime as MinMax;
			this.spawnTimer = Phaser.Math.RND.realInRange(minMax.min, minMax.max);
		}
	}

	removeCloud(cloud: Phaser.GameObjects.Image): void {
		const index = this.clouds.findIndex((c) => c.image == cloud);
		if (index > -1) {
			const cloud = this.clouds.splice(index, 1)[0];
			cloud.image.destroy();
		}
	}
}
